class PromotionsProducts extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initCarousel();
  }

  initCarousel() {
    const sliderElm = this.querySelector('.swiper');

    this.swiper = new Swiper(sliderElm, {
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: {
        enabled: true,
        nextEl: this.querySelector('[data-carousel-next]'),
        prevEl: this.querySelector('[data-carousel-prev]'),
      },
    });
  }
}

if (!customElements.get('promotions-products')) {
  customElements.define('promotions-products', PromotionsProducts);
}